import type { NavigateFunction } from 'react-router-dom'
import type { COHORT_TYPE, IStateReducer } from '~/types/compare-cohorts-context'
import type { IGetSeriesDataBody } from '~/types/graph-builder'

export const setCohortsLocalStorageParams = (
  obj: Record<string, Record<string, string | string[] | null>>,
  key: string
): void => {
  const filters = JSON.parse(localStorage.getItem(key) || '{}')

  const newFilters = {
    cohort1: {
      ...filters.cohort1,
      ...obj.cohort1,
    },
    cohort2: {
      ...filters.cohort2,
      ...obj.cohort2,
    },
  }

  localStorage.setItem(key, JSON.stringify(newFilters))
}

export const setURLParamsForCohorts = (
  cohort: COHORT_TYPE,
  obj: Record<string, Record<string, string | string[]>>,
  query: URLSearchParams,
  navigate: NavigateFunction
): void => {
  Object.keys(obj).forEach((key) => {
    const val = obj[key]
    query.set(cohort, JSON.stringify(val))
  })

  navigate({ search: `${query.toString()}` }, { replace: true })
}

export const clearURLParamsAndLocalStorageForCompare = (
  cohortToClear: string,
  { pathname, search }: { pathname: string; search: string },
  navigate: NavigateFunction,
  localStorageKey: string
): void => {
  const query = new URLSearchParams(search)
  const localStorageContent = localStorage.getItem(localStorageKey)
  const parsedStorage = localStorageContent && JSON.parse(localStorageContent)

  delete parsedStorage[cohortToClear]

  query.delete(cohortToClear)

  localStorage.setItem(localStorageKey, JSON.stringify(parsedStorage))
  navigate(`${pathname}?${query.toString()}`, { replace: true })
}

export const getCohortBodies = (
  kpiField: string,
  normalizedBy: string[],
  state: IStateReducer,
  values: string[],
  appKey?: string,
  deviceType?: string
): IGetSeriesDataBody[] => {
  const bodies = values.map((value) => {
    const singleBody = {
      app_key: appKey || '',
      breakdowns: [],
      device_type: deviceType || '',
      filters: [
        {
          condition_type: 'gt',
          key: 'installation_date',
          values: [state.computedFiltersDate.range.start],
        },
        {
          condition_type: 'lt',
          key: 'installation_date',
          values: [new Date(state.computedFiltersDate.range.end).toISOString().split('T')[0]],
        },
      ],
      kpi_values: {
        field: kpiField,
        normalize_by: normalizedBy,
        values: [value],
        with_inf: false,
        with_sup: false,
        with_trend: false,
      },
    }

    state.computedFilters.forEach((filter) => {
      switch (filter.key) {
        case 'breakdown':
        case 'kpi':
          return
        case 'placement_key':
      }

      if (filter.value?.length == 0) {
        return
      }

      singleBody.filters.push({
        condition_type: 'in',
        key: filter.key,
        values: filter.value,
      })
    })
    return singleBody
  })
  return bodies
}
